export const URL_PARAMETER_CLOSE_TARGET = 'Source';
export const URL_PARAMETER_DOCUMENT = 'document';
export const URL_PARAMETER_TEMPLATE_NAME = 'templateName';
export const URL_PARAMETER_LIBRARY = 'library';
// DEPRECATED - Indicates URL of XSN to open
export const URL_PARAMETER_TEMPLATE = 'template';
export const URL_PARAMETER_PATH = 'path';
export const URL_PARAMETER_FV_DOCUMENT_PATH = 'FVNetworkDocument';
